/* Skinny Genie redesign: static content pages. Highlights the active sub-nav
   link as the visitor scrolls past each section. */
document.addEventListener('DOMContentLoaded', function(){
  var subnav = document.querySelector('.sg-subnav');
  if(!subnav) return;
  var links = Array.from(subnav.querySelectorAll('a[href^="#"]'));
  var sections = links.map(function(a){ return document.getElementById(a.getAttribute('href').slice(1)); }).filter(Boolean);
  if(!sections.length) return;
  function onScroll(){
    var pos = window.scrollY + 140;
    var current = sections[0];
    sections.forEach(function(sec){ if(sec.offsetTop <= pos) current = sec; });
    links.forEach(function(a){
      a.classList.toggle('active', a.getAttribute('href') === '#' + current.id);
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
});
